import Text from '@components/Text/Text';
import { TypographyProps, useTheme } from '@mui/material';
import { LabelValueContainer, LabelText } from './LabelValueText.styles';

export interface LabelValueTextProps {
  label: string;
  value: string | null | undefined | number | boolean;
  hideButtonBorder?: boolean;
  labelProps?: Omit<TypographyProps, 'fontWeight' | 'variant'>;
  valueProps?: Omit<TypographyProps, 'fontWeight' | 'variant'>;
}

const LabelValueText: React.FC<LabelValueTextProps> = ({
  label,
  value,
  hideButtonBorder = false,
  labelProps,
  valueProps,
}) => {
  const theme = useTheme();
  return (
    <LabelValueContainer hideButtonBorder={hideButtonBorder}>
      <LabelText variant='h6' fontWeight='fontWeightMedium' {...labelProps}>
        {label}
      </LabelText>
      <Text
        variant='h6'
        fontWeight='fontWeightSemiBold'
        color={theme.palette.black.A100}
        sx={{ flex: 3 }}
        {...valueProps}
      >
        {value && value !== '' ? value : '-'}
      </Text>
    </LabelValueContainer>
  );
};

export default LabelValueText;
